import { render } from "./PostsDrafts.vue?vue&type=template&id=2f11151c"
import script from "./PostsDrafts.vue?vue&type=script&lang=js"
export * from "./PostsDrafts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__